import api from '../api';

const b2cAccountService = {
  login(email, password) {
    return api.post('/api/v1/b2c/auth/login', {email, password});
  },

  register(data) {
    return api.post('/api/v1/b2c/auth/register', data);
  },

  googleLogin(token) {
    return api.post('/api/v1/b2c/auth/google', {token});
  },

  getProfile() {
    return api.get('/api/v1/b2c/account/me');
  },

  updateProfile(data) {
    return api.put('/api/v1/b2c/account/me', data);
  },

  verifyEmail(token) {
    return api.post('/api/v1/b2c/auth/verify-email', {token});
  },

  forgotPassword(email) {
    return api.post('/api/v1/b2c/auth/forgot-password', {email});
  },

  resetPassword(token, newPassword) {
    return api.post('/api/v1/b2c/auth/reset-password', {token, newPassword});
  },

  generateCheckinCode() {
    return api.post('/api/v1/b2c/account/checkin-code');
  },

  getIdentityCodes() {
    return api.get('/api/v1/b2c/account/identity-codes');
  },

  deleteAccount() {
    return api.delete('/api/v1/b2c/account/me');
  },

  uploadProfilePicture(file) {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/api/v1/b2c/account/me/picture', formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    });
  },

  deleteProfilePicture() {
    return api.delete('/api/v1/b2c/account/me/picture');
  },

  async getProfilePictureBlobUrl() {
    try {
      const response = await api.get('/api/v1/b2c/account/me/picture', {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], {type: response.headers['content-type']});
      return URL.createObjectURL(blob);
    } catch {
      return null;
    }
  },
};

export default b2cAccountService;
